import React, { useState } from 'react';

const DropCreator = () => {
  const [image, setImage] = useState(null);
  const [dropLocations, setDropLocations] = useState([]);
  const [showArrow, setShowArrow] = useState(false);

  // Function to handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  // Function to handle drop location creation
  const handleDropLocationCreate = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setDropLocations([...dropLocations, { x, y }]);
    setShowArrow(true);
  };

  // Function to handle arrow movement
  const handleArrowMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setDropLocations([...dropLocations.slice(0, -1), { x, y }]);
  };

  // Render the component
  return (
    <div>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      {image && (
        <div
          style={{ position: 'relative', display: 'inline-block' }}
          onMouseDown={handleDropLocationCreate}
          onMouseMove={showArrow ? handleArrowMove : null}
          onMouseUp={() => setShowArrow(false)}
        >
          <img src={URL.createObjectURL(image)} alt="Uploaded" />
          {showArrow && (
            <div
              style={{
                position: 'absolute',
                left: dropLocations[dropLocations.length - 1].x,
                top: dropLocations[dropLocations.length - 1].y,
                width: '20px',
                height: '20px',
                backgroundColor: 'red',
                borderRadius: '50%',
              }}
            />
          )}
          {dropLocations.map((location, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                left: location.x,
                top: location.y,
                width: '10px',
                height: '10px',
                backgroundColor: 'green',
                borderRadius: '50%',
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DropCreator;